import { createAction, createReducer } from 'redux-act';
import { API_INSTANCE } from '../../utils/service-http';
import { getAppLocale } from '../../utils/app-locale';
import { api_base_url, m580_distributed_ranges } from '../../constants';
import ProductInformationCache from '../../persistence/description-cache';
import { appConfiguration } from '../../utils/app-starter';

const DEFAULT_STATE_RACKS = { ranges: [], isLoading: false, error: null };


const getRacksStarted = createAction('GET_RACKS_STARTED');
const getRacksSuccess = createAction('GET_RACKS_SUCCESS');
const getRacksFailed = createAction('GET_RACKS_FAILED');


export const racksReducer = createReducer(function (on, off) {
  on(getRacksStarted, (state, payload) => {
    return {
      ranges: [],
      isLoading: true,
      error: null,
    };
  });
  on(getRacksSuccess, (state, payload) => {
    return {
      ranges: payload,
      isLoading: false,
      error: null,
    };
  });
  on(getRacksFailed, (state, payload) => {
    return {
      ranges: [],
      isLoading: false,
      error: null,
    };
  });
}, DEFAULT_STATE_RACKS);


export const getRacks = (configuration, criteria, islandConfiguration, isIsland = false, ruggedization = null) => {

  const mainOverrideString = appConfiguration.main ? `&main=${appConfiguration.main}` : '';

  const rackRange = (isIsland && configuration.rangeInfo?.extensionRackRange) ? configuration.rangeInfo.extensionRackRange : configuration.rangeInfo.rangeName;
  // Used to retrieve redundant extension rack only : if the main rack is redundant, then extension rack should be redundant as well.
  // All racks types should be returned for the main rack.
  // This is obsolete today, we always return all power supplies regardless of the main rack power supply type.
  const powerSupplyType = 'all';

  const payload = {
    rangeName: rackRange,
    criteria: { ...criteria, },
    distributorUnscoping: appConfiguration.distributorUnscoping,
    powerSupplyType,
    ruggedization
  };

  if (isIsland && m580_distributed_ranges.includes(configuration?.rangeInfo?.rangeName) && islandConfiguration?.headModule?.id) {
    payload.selectedCRA = islandConfiguration.headModule.id;
  }

  return async dispatch => {
    dispatch(getRacksStarted());
    return API_INSTANCE.post(`${api_base_url}/compatible-racks?locale=${getAppLocale()}${mainOverrideString}`, payload)
      .then((success) => {
        // Update description
        const allReferences = [];
        const ranges = success.data.payload.categories;
        for (let range of ranges) {
          allReferences.push(...range.references);
        }
        ProductInformationCache.loadReferencesDescriptions(allReferences.map(r => r.id));
        dispatch(getRacksSuccess(ranges));
        return success.data.payload;
      }).catch((error) => {
        dispatch(getRacksFailed(error.message));
        throw error;
      });
  }
}
